import { render, staticRenderFns } from "./FourNurseDialog.vue?vue&type=template&id=e507a04a&scoped=true"
import script from "./FourNurseDialog.vue?vue&type=script&lang=ts"
export * from "./FourNurseDialog.vue?vue&type=script&lang=ts"
import style0 from "./FourNurseDialog.vue?vue&type=style&index=0&id=e507a04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e507a04a",
  null
  
)

export default component.exports